import UserEntityFactory from '../Entities/factory.js'
import {UserErrorsFactory} from '../Errors/factory.js'
import {UserRequestsFactory} from '../Requests/factory.js'
import UserValueObjectsFactory from '../ValueObjects/factory.js'
import {FromLeadHitUserVOToLeadHitUserRequestMapper} from './FromLeadHitUserVOToLeadHitUserRequestMapper.js'
import {FromRawDataToGetConversationEntityUserMapper} from './FromRawDataToGetConversationEntityUserMapper.js'
import {FromSubscriptionsParamRequestToApiBodyMapper} from './FromSubscriptionsParamRequestToApiBodyMapper.js'
import {FromSubscriptionsRawDataToSpecificSubscriptionsMapper} from './FromSubscriptionsRawDataToSpecificSubscriptionsMapper.js'
import {FromUserRawDataToUserEntityMapper} from './FromUserRawDataToUserEntityMapper.js'
import HTTPUserRepositoryToContactResponseValueObjectMapper from './HTTPUserRepositoryToContactResponseValueObjectMapper.js'
import HTTPUserTakeOutListToUserTakeOutListValueObjectMapper from './HTTPUserTakeOutListToUserTakeOutListValueObjectMapper.js'

export default class UserMappersFactory {
  static hTTPUserRepositoryToContactResponseValueObjectMapper = ({config}) =>
    new HTTPUserRepositoryToContactResponseValueObjectMapper({
      config,
      contactResponseValueObjectFactory: UserValueObjectsFactory.contactResponseValueObjectFactory
    })

  static hTTPUserTakeOutListToUserTakeOutListValueObjectMapper = ({config}) =>
    new HTTPUserTakeOutListToUserTakeOutListValueObjectMapper({
      userTakeoutListValueObjectFactory: UserValueObjectsFactory.userTakeoutListValueObjectFactory,
      config
    })

  static fromLeadHitUserVOToLeadHitUserRequestMapper = ({config}) =>
    new FromLeadHitUserVOToLeadHitUserRequestMapper({
      leadHitUserRequestFactory: UserRequestsFactory.leadHitUserRequestFactory,
      config
    })

  static fromUserRawDataToUserEntityMapper = ({config}) =>
    new FromUserRawDataToUserEntityMapper({
      config,
      userEntityFactory: UserEntityFactory.userEntity
    })

  static fromRawDataToGetConversationEntityUserMapper = ({config}) =>
    new FromRawDataToGetConversationEntityUserMapper({
      config,
      conversationUserEntity: UserEntityFactory.conversationUserEntity,
      getConversationUserErrorFactory: UserErrorsFactory.getConversationUserError
    })

  static fromSubscriptionsRawDataToSpecificSubscriptionsMapper = ({config}) =>
    new FromSubscriptionsRawDataToSpecificSubscriptionsMapper({
      config,
      subscriptionsUserValueObjectFactory: UserValueObjectsFactory.subscriptionsUserValueObject
    })

  static fromSubscriptionsParamRequestToApiBodyMapper = ({config}) =>
    new FromSubscriptionsParamRequestToApiBodyMapper({config})
}
